<template>
  <div v-if="$store.state.responsive.viewDesktopLists" id="contract-filters">
    <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
      <div class="row">
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="contractId">Nº Contrato</label>
            <input type="text" class="form-control generalInput" id="contractId" v-model.trim="contractId" />
          </div>
        </div>
        <div class="col-12 col-lg-3" v-if="!comprobarRolCompany()">
          <div class="form-group">
            <label class="generalLabel" for="id">ID Incidencia</label>
            <input type="texz" class="form-control generalInput" id="incidentId" v-model.trim="incidentId" />
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group multipleSelect">
            <label class="generalLabel" for="status">Estado</label>
            <VueNextSelect class="form-control generalInput" id="status" :options="statusData" v-model.trim="status"
              placeholder="" searchable="true" clear-on-close="true" close-on-select>
            </VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-3" v-if="!comprobarRolCompany()">
          <div class="form-group">
            <label class="generalLabel" for="type">Tipo</label>
            <VueNextSelect class="form-control generalInput" id="type" :options="incidentsTypes" v-model.trim="type"
              placeholder="" searchable="true" clear-on-close="true" close-on-select>
            </VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-3" v-if="!comprobarRolCompany()">
          <div class="form-group">
            <label class="generalLabel" for="type">Prioridad</label>
            <VueNextSelect class="form-control generalInput" id="priority" :options="priorityData" v-model.trim="priority"
              placeholder="" searchable="true" clear-on-close="true" close-on-select>
            </VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="createdAt">Fecha de creación</label>
            <DatePicker v-model="createdAt" mode="date" :model-config="modelConfig">
              <template v-slot="{ togglePopover }">
                <input @click="togglePopover()" class="form-control bg-white generalInput" readonly v-model="createdAt" />
                <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
              </template>
            </DatePicker>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="closedAt">Fecha de cierre</label>
            <DatePicker v-model="closedAt" mode="date" :model-config="modelConfig">
              <template v-slot="{ togglePopover }">
                <input @click="togglePopover()" class="form-control bg-white generalInput" readonly v-model="closedAt" />
                <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
              </template>
            </DatePicker>
          </div>
        </div>
        <div class="col-12 col-lg-12">
          <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
            <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
            <button class="btn btn-primary generalPrimaryButton">Buscar</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div v-else>
    <div class="filterHeader link-primary d-flex align-items-center justify-content-between" data-toggle="collapse"
      href="#filterCollapse" role="button" aria-expanded="false" aria-controls="filterCollapse">
      <p class="m-0">
        FILTROS
      </p>
      <v-icon name="bi-filter" scale="1.5" />
    </div>
    <hr />
    <div class="collapse" id="filterCollapse">
      <form @submit.prevent="filter()" v-on:keypress.enter.prevent="enterKey">
        <div class="row">
          <div class="col-12 col-lg-3" v-if="!comprobarRolCompany()">
            <div class="form-group">
              <label class="generalLabel" for="contractId">Nº Contrato</label>
              <input type="text" class="form-control generalInput" id="contractId" v-model.trim="contractId" />
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="incidentId">Nº Incidencia</label>
              <input type="text" class="form-control generalInput" id="incidentId" v-model.trim="incidentId" />
            </div>
          </div>
          <div class="col-12 col-lg-3" v-if="!comprobarRolCompany()">
            <div class="form-group">
              <label class="generalLabel" for="type">Estado</label>
              <VueNextSelect class="form-control generalInput" id="status" :options="statusData" v-model.trim="status"
                placeholder="" searchable="true" clear-on-close="true" close-on-select>
              </VueNextSelect>
            </div>
          </div>
          <div class="col-12 col-lg-3" v-if="!comprobarRolCompany()">
            <div class="form-group">
              <label class="generalLabel" for="type">Tipo</label>
              <VueNextSelect class="form-control generalInput" id="type" :options="incidentsTypes" v-model.trim="type"
                placeholder="" searchable="true" clear-on-close="true" close-on-select>
              </VueNextSelect>
            </div>
          </div>

          <div class="col-12 col-lg-3" v-if="!comprobarRolCompany()">
            <div class="form-group">
              <label class="generalLabel" for="type">Prioridad</label>
              <VueNextSelect class="form-control generalInput" id="priority" :options="priorityData"
                v-model.trim="priority" placeholder="" searchable="true" clear-on-close="true" close-on-select>
              </VueNextSelect>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="createdAt">Fecha de creación </label>
              <DatePicker v-model="createdAt" mode="date" :model-config="modelConfig">
                <template v-slot="{ togglePopover }">
                  <input @click="togglePopover()" class="form-control bg-white generalInput" readonly
                    v-model="createdAt" />
                  <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
                </template>
              </DatePicker>
            </div>
          </div>
          <div class="col-12 col-lg-3">
            <div class="form-group">
              <label class="generalLabel" for="closedAt">Fecha de cierre </label>
              <DatePicker v-model="closedAt" mode="date" :model-config="modelConfig">
                <template v-slot="{ togglePopover }">
                  <input @click="togglePopover()" class="form-control bg-white generalInput" readonly
                    v-model="closedAt" />
                  <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate" @click="togglePopover()" />
                </template>
              </DatePicker>
            </div>
          </div>
          <div class="col-12 col-lg-3" v-if="!comprobarRolCompany()">
            <div class="form-group">
              <label class="generalLabel" for="type">Tipo:</label>
              <VueNextSelect class="form-control generalInput" id="priority" :options="incidentsTypes" v-model.trim="priority"
                placeholder="" searchable="true" clear-on-close="true" close-on-select>
              </VueNextSelect>
            </div>
          </div>
          <div class="col-12 col-lg-12">
            <div class="h-100 d-flex justify-content-end align-items-end align-content-end">
              <button class="btn generalSecondaryButton" @click="cleanSearch()">Limpiar</button>
              <button class="btn btn-primary generalPrimaryButton">Buscar</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { DatePicker } from "v-calendar";
import VueNextSelect from "vue-next-select";
//import axios from "axios";
import useVuelidate from "@vuelidate/core";
import { priorityData, priorityDataTraduction, statusData, statusDataTraduction, incidentsTypes, incidentsTypesTraduction } from "../Issues/IssuesList/common.js";


export default {
  name: "ContractFilters",
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    DatePicker,
    VueNextSelect,
  },
  data() {
    return {
      contractId: "",
      incidentId: "",
      status: "",
      type: "",
      incidentsTypes: incidentsTypes,
      incidentsTypesTraduction: incidentsTypesTraduction,
      priority: "",
      priorityData: priorityData,
      priorityDataTraduction: priorityDataTraduction,
      statusData: statusData,
      statusDataTraduction: statusDataTraduction,
      createdAt: "",
      closedAt: "",
      modelConfig: {
        type: "string",
        mask: "DD/MM/YYYY",
      },
      rol: this.$cookies.get("rol"),
    };
  },
  validations() {
    return {
    };
  },
  created() {
  },
  computed: {
    filtersApplied() {
      return {
        contractId: this.contractId,
        incidentId: this.incidentId,
        status: this.statusDataTraduction[this.statusData.indexOf(this.status)],
        type: this.incidentsTypesTraduction[this.incidentsTypes.indexOf(this.type)],
        priority: this.priorityDataTraduction[this.priorityData.indexOf(this.priority)],
        createdAt: this.createdAt,
        closedAt: this.closedAt
      };
    },
  },
  methods: {
    filter() {
      this.$emit("filter", this.filtersApplied);
    },

    cleanSearch() {
      this.contractId = "",
      this.incidentId = "";
      this.status = "";
      this.type = "";
      this.type = "";
      this.priority = "";
      this.createdAt = "",
      this.closedAt = "",
      this.filtersApplied.contractId = "",
      this.filtersApplied.incidentId = "",
      this.filtersApplied.status = "",
      this.filtersApplied.type = "",
      this.filtersApplied.priority = "",
      this.filtersApplied.createdAt = "",
      this.filtersApplied.closedAt = ""

    },
    enterKey: function (e) {
      if (e.keyCode === 13) {
        this.filter();
      }
    },
    comprobarRolCompany() {
      let value = false;
      if (this.rol != undefined && this.rol != null) {
        if (this.rol.includes("Backoffice_member_empresas")) {
          value = true;
        }
      }
      return value;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../../scss/variables.scss';

.filterHeader {
  font-size: 1.143rem;
  line-height: 1.5;
}

.link-primary {
  color: $primary;
  cursor: pointer;

  &:hover {
    color: $primary-hover;
  }
}

.multipleSelect .generalInput {
  padding-right: 27px;
}

.multipleSelect .multiSelect .vue-select-input-wrapper {
  padding-top: 15px;

  .vue-input {
    z-index: 9999;
    border: 1px solid #e5e4e4;
    background-color: #ffff;

    input {
      font-size: 1.1rem;
    }
  }
}

.multipleSelect .multiSelect .vue-dropdown {
  margin-top: 2px;
  border-top: 55px solid #ffff;
}

.adavancedSearch {
  @media (max-width: 991px) {}
}
</style>
